var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u624B\u673A\u53F7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5B8C\\u5584\\u4FE1\\u606F\\u9875",
    transform: "translate(-51, -558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u624B\\u673A\\u53F7",
    transform: "translate(51, 558)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#979797",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(4, 2)",
    fill: "#111111",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45714285,0 L18.5428571,0 C20.4521429,0 22,1.60062499 22,3.57500002 L22,22.425 C22,24.399375 20.4521429,26 18.5428571,26 L3.45714285,26 C1.54785713,26 0,24.399375 0,22.425 L0,3.57500002 C0,1.60062502 1.54785713,0 3.45714285,0 Z M3.45714285,1.95 C3.04037408,1.95 2.64067507,2.12120487 2.34597505,2.42595149 C2.05127502,2.73069811 1.88571429,3.14402322 1.88571429,3.57500002 L1.88571429,22.425 C1.88571429,22.8559768 2.05127502,23.2693019 2.34597505,23.5740485 C2.64067507,23.8787951 3.04037408,24.05 3.45714285,24.05 L18.5428571,24.05 C18.9596259,24.05 19.3593249,23.8787951 19.654025,23.5740485 C19.948725,23.2693019 20.1142857,22.8559768 20.1142857,22.425 L20.1142857,3.57500002 C20.1142857,3.14402322 19.948725,2.73069811 19.654025,2.42595149 C19.3593249,2.12120487 18.9596259,1.95 18.5428571,1.95 L3.45714285,1.95 Z M7.54285715,19.825 C7.54285715,19.2865224 7.96498867,18.85 8.48571429,18.85 L13.5142857,18.85 C14.0350113,18.85 14.4571429,19.2865224 14.4571429,19.825 C14.4571429,20.3634776 14.0350113,20.8 13.5142857,20.8 L8.48571429,20.8 C7.96498867,20.8 7.54285715,20.3634776 7.54285715,19.825 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.248ef3cf269f4a82e78d106aaa79a0b2.svg";
export { ForwardRef as ReactComponent };